/**
 * Registration schedule already targets a different identity than Feed and/or lastSet
 * (worker CAMPAIGN_UPDATE went silent after a failed soft-defer flush). Soft-defer must re-arm.
 */

import type { Temporal } from '@js-temporal/polyfill'
import type {
  IPlaybackScheduleRoot,
  IScheduleRootAssignment
} from '@lucimark/shared/models/player-registration-payload'
import { combineRegistrationScheduleRootsForPlayback } from '@lucimark/shared/helpers/combineRegistrationScheduleRootsForPlayback'
import { getPlaybackScheduleMaterializationIdentity } from '@lucimark/shared/helpers/playbackScheduleMaterializationIdentity'

export function isRegistrationAheadOfPlayback(options: {
  desiredId: string | null
  feedId: string | null
  loadedId: string | null
}): boolean {
  if (options.desiredId == null) {
    return false
  }
  return options.desiredId !== options.feedId || options.desiredId !== options.loadedId
}

/** Live overlay/settle hold: combined registration roots vs on-air Feed (and lastSet when known). */
export function isRegistrationScheduleAheadOfOnAir(options: {
  roots: readonly IScheduleRootAssignment[]
  assignedMasterPlaylistUrn?: string | null
  campaign: IPlaybackScheduleRoot | null
  loadedRoot?: IPlaybackScheduleRoot | null
  now: Temporal.Instant
}): boolean {
  const desired = combineRegistrationScheduleRootsForPlayback(
    options.roots,
    options.now,
    { masterPlaylistUrn: options.assignedMasterPlaylistUrn }
  )
  const campaignId = getPlaybackScheduleMaterializationIdentity(options.campaign)
  return isRegistrationAheadOfPlayback({
    desiredId: getPlaybackScheduleMaterializationIdentity(desired),
    feedId: campaignId,
    loadedId: getPlaybackScheduleMaterializationIdentity(options.loadedRoot ?? options.campaign)
  })
}
